import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import AnimatedSection from '../Animation/AnimatedSection';

const AboutSection = styled.section`
  padding: 6rem 0;
  background-color: ${props => props.theme.colors.white};
`;

const AboutContainer = styled.div`
  display: flex;
  flex-direction: column;
  
  @media (min-width: ${props => props.theme.breakpoints.lg}) {
    flex-direction: row;
    align-items: center;
  }
`;

const AboutContent = styled.div`
  flex: 1;
  
  @media (min-width: ${props => props.theme.breakpoints.lg}) {
    padding-right: 2rem;
  }
`;

const AboutTitle = styled(motion.h2)`
  color: ${props => props.theme.colors.primary};
  position: relative;
  padding-bottom: 1rem;
  text-transform: uppercase;
  font-style: italic;
  
  &:after {
    content: '';
    position: absolute;
    left: 50%;
    bottom: 0;
    width: 60px;
    height: 3px;
    background-color: ${props => props.theme.colors.grayMedium};
    transform: translateX(-50%);
    
    @media (min-width: ${props => props.theme.breakpoints.md}) {
      left: 0;
      transform: none;
    }
  }
`;

const AboutText = styled(motion.p)`
  margin-top: 1.5rem;
  font-size: ${props => props.theme.fontSizes.bodyLg};
  line-height: ${props => props.theme.lineHeights.relaxed};
  text-align: justify;
  text-justify: inter-word;
`;

const AboutImageContainer = styled.div`
  flex: 1;
  margin-top: 2rem;
  
  @media (min-width: ${props => props.theme.breakpoints.lg}) {
    margin-top: 0;
  }
`;

const AboutImagePlaceholder = styled(motion.div)`
  width: 100%;
  background-color: ${props => props.theme.colors.grayLight};
  border-radius: ${props => props.theme.borderRadius.medium};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${props => props.theme.colors.grayMedium};
  overflow: hidden;
`;

const AboutUs = () => {
  const [titleRef, titleInView] = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  return (
    <AboutSection id="quem-somos">
      <div className="container">
        <AboutContainer>
          <AboutContent>
            <AboutTitle
              ref={titleRef}
              initial={{ opacity: 0, y: 20 }}
              animate={titleInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
              transition={{ duration: 0.6 }}
            >
              Quem Somos
            </AboutTitle>
            
            <AnimatedSection animation="fadeInLeft" delay={0.2}>
              <AboutText>
                A LM Consulting é uma consultoria especializada em conformidade regulatória, eficiência energética e segurança elétrica para produtos de diversos segmentos. Unimos rigor técnico, visão de mercado e experiência prática para oferecer soluções que garantem acesso seguro e rápido ao mercado brasileiro.
              </AboutText>
            </AnimatedSection>
            
            <AnimatedSection animation="fadeInLeft" delay={0.4}>
              <AboutText>
                Trabalhamos lado a lado com nossos clientes, atuando como um parceiro estratégico em todas as etapas do processo de certificação. Desde o planejamento até a aprovação final, conduzimos cada projeto com clareza, precisão e compromisso absoluto com os resultados.
              </AboutText>
            </AnimatedSection>
            
            <AnimatedSection animation="fadeInLeft" delay={0.6}>
              <AboutText>
                Nossa abordagem é colaborativa, transparente e orientada a performance, assegurando que cada produto avance com confiança, qualidade e total conformidade.
              </AboutText>
            </AnimatedSection>
          </AboutContent>
          
          <AboutImageContainer>
            <AnimatedSection animation="fadeInRight" delay={0.4}>
              <AboutImagePlaceholder
                whileHover={{ scale: 1.03 }}
                transition={{ duration: 0.3 }}
              >
                <img
                  src="/assets/ChatGPT Image Dec 8, 2025, 07_39_15 PM.png"
                  alt="Equipe LM Consulting"
                  style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '16px' }}
                />
              </AboutImagePlaceholder>
            </AnimatedSection>
          </AboutImageContainer>
        </AboutContainer>
      </div>
    </AboutSection>
  );
};

export default AboutUs;
